import React, { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="privacy-policy" style={{ marginTop: "60px",  marginBottom: "100px" }}>
        <div className="container">
          <div className="sm-box">
            <h4>Privacy Policy</h4>
            <p>
              <i>Effective Date: [06 NOV 2023]</i>
            </p>

            <div className="content">
              <div className="para-section">
                <p>
                  At DataFluent Analytics, found at{" "}
                  <a href="https://datafluent.xyz/" target="_blank" rel="noopener noreferrer">
                    https://datafluent.xyz/
                  </a>
                  , safeguarding the privacy of our visitors is a top priority. This Privacy Policy outlines
                  the types of information collected and recorded by DataFluent Analytics and explains
                  how we utilize this information. Should you have further inquiries or need additional
                  details regarding our Privacy Policy, feel free to reach out to us by email{" "}
                  <a href="mailto:dfaadmin@datafluent.xyz">dfaadmin@datafluent.xyz</a> or call us at
                  +880-1994388587. Please note that this Privacy Policy pertains exclusively to our
                  online activities and applies to visitors accessing our website. It covers information
                  shared and/or collected through the DataFluent Analytics website and does not extend
                  to data collected offline or through channels other than this website.
                </p>

                <p>
                  <strong>Your (visitor/user of Datafluent Analytic’s website) Consent </strong>
                  <br />
                  By utilizing our website, you explicitly agree to abide by and consent to the terms
                  outlined in our Privacy Policy.
                </p>
                <p>
                  <strong>Data We Gather </strong>
                  <br />
                  The information requested from you and the purposes for its collection will be
                  explicitly communicated when we seek your details. In the event of direct
                  communication with us, additional details like your name, email address, phone
                  number, message contents, attachments, and any voluntarily provided information
                  may be received. During the Account registration process, we may inquire about
                  your contact details, encompassing information such as your name, company name,
                  address, email address, and telephone number.
                </p>

                <div>
                  <strong>How DFA may use your data </strong>
                  <br />
                  We employ the gathered information for diverse purposes, which include:
                  <ul>
                    <li>Managing the operations and upkeep of our website</li>
                    <li>Enhancing, customizing, and extending the features of our website</li>
                    <li>Analyzing and comprehending your usage patterns on our website</li>
                    <li>Creating new products, services, features, and functionalities</li>
                    <li>
                      Directly communicating with you or through our partners, for customer service,
                      updates, website-related information, and promotional activities
                    </li>
                    <li>Delivering emails to you</li>
                    <li>Identifying and mitigating fraudulent activities</li>
                  </ul>

                  <p>
                    <strong>Log Files </strong> 
                    <br />
                    DataFluent Analytics adheres to a conventional practice of employing log files, a
                    procedure common among hosting companies to record visitor activities on
                    websites. Log files, a component of hosting services' analytics, capture data
                    such as internet protocol (IP) addresses, browser type, Internet Service Provider
                    (ISP), date and time stamps, referring/exit pages, and potentially the number
                    of clicks. Importantly, this information is not associated with personally
                    identifiable details. The primary objective of utilizing this data is to analyze
                    trends, manage the site, monitor users' navigation patterns, and compile
                    demographic information.
                  </p>

                  <p>
                    <strong>Privacy Policies of Advertising Partners </strong> 
                    <br />
                    Third-party ad servers or ad networks utilize technologies such as cookies,
                    JavaScript, or Web Beacons within their advertisements and links featured on
                    DataFluent Analytics. These technologies are transmitted directly to users'
                    browsers and automatically capture their IP addresses. The purpose of employing
                    these technologies is to assess the efficacy of advertising campaigns and/or
                    customize the advertising content displayed on websites visited by users. It
                    is important to note that DataFluent Analytics lacks access to or control over
                    the cookies utilized by third-party advertisers.
                  </p>

                  <p>
                    <strong>Privacy Policies of External Parties </strong> 
                    <br />
                    The Privacy Policy of DataFluent Analytics does not extend to other advertisers
                    or websites, and it may encompass their practices, along with guidance on opting
                    out of specific options. You have the choice to deactivate cookies by adjusting
                    settings in your browser. For more comprehensive details on managing cookies
                    with particular web browsers, please refer to the respective websites of those
                    browsers.
                  </p>
                  <p>
                    <strong>Cookies & Web Beacons </strong> 
                    <br />
                    Similar to other websites, DataFluent Analytics employs 'cookies.' These cookies
                    serve to store information, encompassing visitors' preferences and the specific
                    pages they accessed or visited on the website. This information is utilized
                    to enhance user experiences by tailoring our webpage content according to
                    visitors' browser type and/or other relevant details.
                  </p>

                  <strong>Right for Data Protection under GDPR </strong> 
                  <br />
                  We want to ensure you are fully informed about your data protection rights. Every
                  user is entitled to the following: The right to rectification: You can request
                  corrections to any information you deem inaccurate and completion of incomplete
                  information.
                  <ul>
                    <li>
                      The right to erasure: You can request the removal of your data under specific
                      conditions.
                    </li>
                    <li>
                      The right to restrict processing: You can request limitations on the processing
                      of your data under certain conditions.
                    </li>
                    <li>
                      The right to object to processing: You can object to our processing of your
                      data under specific conditions.
                    </li>
                    <li>
                      The right to data portability: You can request the transfer of the data we
                      have collected to another organization or directly to you under certain
                      conditions.
                    </li>
                  </ul>

                  <p>
                    <strong>Information Regarding Children </strong> 
                    <br />
                    Ensuring the safety of children during internet use is integral to our commitment.
                    We urge parents and guardians to actively observe, participate in, and monitor
                    their online activities. DataFluent Analytics does not intentionally gather
                    any Personal Identifiable Information from children under the age of 13. If
                    you suspect that your child has provided such information on our website,
                    please contact us promptly, and we will make every effort to promptly eliminate
                    such data from our records.
                  </p>

                  <p>
                    <strong>Contact Us </strong> 
                    <br />
                    For any further queries or objections, please email us at{" "}
                    <a href="mailto:dfaadmin@datafluent.xyz">dfaadmin@datafluent.xyz</a> or call us
                    +880-1994388587. We are happy to hear from you. Thank you!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;